import { render, staticRenderFns } from "./Postgrado-mod.vue?vue&type=template&id=e028885c"
import script from "./Postgrado-mod.vue?vue&type=script&lang=js"
export * from "./Postgrado-mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports